import { User } from "../@core/data/users";
import { Customer } from "./customer.model";
import { Product } from "./product.model";

export class Loan {
  id?: string;

  issueDate?: Date;
  issueDateSeconds?: number;
  issueDateMinutes?: number;
  issueDateHours?: number;
  issueDateDay?: number; //day of the month
  issueDateMonth?: number;
  issueDateYear?: number;
  issueDateWeekDay?: number; //the day of the week, Sunday=0 - Saturday=6

  code?: string;
  warehouseId?: string;
  note?: string;
  tags?: string[];

  remindType?: string; //day/week/month/year
  remindPaidNumber?: number;
  remindDate?: Date;
  lastRemindDate?: Date;
  nextRemindDate?: Date;
  remindAmount?: number;

  detailAmount?: number;
  profitPercent?: number;
  profitAmount?: number;
  vatPercent?: number;
  vatAmount?: number;
  totalAmount?: number;
  //payment
  totalPaidAmount?: number;
  totalProfit?: number;

  isCancel?: boolean;
  isClosed?: boolean;
  isPrint?: boolean;
  status?: string;
  noPrint?: number;

  //customer - membership
  customer?: Customer;
  customerId?: string;
  customerName?: string;
  lastDebitAmount?: number;

  //product
  product?: Product;
  productId?: string;
  productName?: string;

  //Advance
  groupId?: string;
  groupName?: string;

  //detail
  loanPaymentDetails?: LoanPaymentDetail[];
  isDetailChanged?: boolean;

  //inventory
  isInventory?: boolean;
  IssueDateInventory?: Date;

  //default
  shopId?: string;
  timestamp?: number;
  author?: User;
  createdBy?: string;
  createdOn?: Date;
  updatedBy?: string;
  updatedOn?: Date;
  isDeleted?: boolean;
  isActive?: boolean;
  visibility?: string;
  companyId?: string;
}

export class LoanPaymentDetail {
  id?: string;
  loanId?: string;
  loan?: Loan;

  issueDate?: Date;
  issueDateSeconds?: number;
  issueDateMinutes?: number;
  issueDateHours?: number;
  issueDateDay?: number; //day of the month
  issueDateMonth?: number;
  issueDateYear?: number;
  issueDateWeekDay?: number; //the day of the week, Sunday=0 - Saturday=6

  paymentDate?: Date;
  amount?: number;
  profitAmount?: number;
  comment?: string;

  //payment
  isPaid?: boolean;
  isCash?: boolean;
  paymentAmount?: number;
  paymentRefund?: number;

  //default
  shopId?: string;
  timestamp?: number;
  author?: User;
  createdBy?: string;
  createdOn?: Date;
  updatedBy?: string;
  updatedOn?: Date;
  isDeleted?: boolean;
  isActive?: boolean;
  visibility?: string;
  companyId?: string;
}
